module.exports = __webpack_public_path__ + "img/17_62.81b95bfd.png";